module.exports = __webpack_public_path__ + "static/media/DinaPart-Motion.96a81ce9.mp4";